export default __webpack_public_path__ + "static/media/mute.ca00bb26.svg";